import mapResponseDatesToColumns from '../mappers/mapResponseDatesToColumns'
import { IResponse } from './columnsResponse'

export default async function(response: Response) {
  const json: IResponse = await response.json()

  return mapResponseDatesToColumns(json)
}
